export enum AssetClass {
    SPOT = 'SPOT',
    PER  = 'PER',
    FUT  = 'FUT',
    OPT  = 'OPT'
}

export const ASSET_CLASSES: AssetClass[] = [
    AssetClass.SPOT,
    AssetClass.PER,
    AssetClass.FUT,
    AssetClass.OPT
];

export const ASSET_CLASS_NAMING: Record<AssetClass, string> = {
    [AssetClass.SPOT]: 'enums.asset-class.spot',
    [AssetClass.PER]:  'enums.asset-class.perpetuals',
    [AssetClass.FUT]:  'enums.asset-class.futures',
    [AssetClass.OPT]:  'enums.asset-class.options'
};
